import type { MenuPageItem } from 'bz-core-controls/controls/general/nested-list-new/stores/menu-store';
import { observable, toJS } from 'mobx';

class OptionsDetailsStore {
  @observable description = '';
  @observable alts = observable.map(new Map());

  constructor(item: MenuPageItem) {
    this.description = item.description;
    this.alts.replace(toJS(item.alternates));
  }
}

export default OptionsDetailsStore;
